// Prosjekt- og timeregistreringstekster for no.
window.PlummeI18n.register('no', {
  'pj.tab.time': 'Timeføring',
  'pj.tab.overview': 'Oversikt',
  'pj.tab.settings': 'Innstillinger',
  'pj.day.mon': 'Man',
  'pj.day.tue': 'Tir',
  'pj.day.wed': 'Ons',
  'pj.day.thu': 'Tor',
  'pj.day.fri': 'Fre',
  'pj.day.sat': 'Lør',
  'pj.day.sun': 'Søn',
  'pj.person.fallback': 'deg',
  'pj.time.title': 'Timeføring for {name}',
  'pj.week.label': 'Uke {week}',
  'pj.week.word': 'Uke',
  'pj.week.pick': 'Velg uke',
  'pj.week.current': 'Denne uken',
  'pj.week.back': 'Tre uker tilbake',
  'pj.week.forward': 'Tre uker fram',
  'pj.week.prev': 'Forrige uke',
  'pj.week.next': 'Neste uke',
  'pj.month.prev': 'Forrige måned',
  'pj.month.next': 'Neste måned',
  'pj.month.entries': 'Registrerte timer i {month}',
  'pj.month.dayHours': '{hours} registrert',
  'pj.view.day': 'Dag',
  'pj.view.week': 'Uke',
  'pj.day.empty': 'Ingen timer registrert denne dagen.',
  'pj.table.projectActivity': 'Prosjekt / aktivitet',
  'pj.table.sum': 'Sum',
  'pj.table.hours': 'Timer',
  'pj.row.new': 'Ny rad',
  'pj.row.add': 'Legg til',
  'pj.row.remove': 'Fjern raden',
  'pj.row.pickBoth': 'Velg prosjekt og aktivitet',
  'pj.select.project': 'Velg prosjekt …',
  'pj.select.activity': 'Velg aktivitet …',
  'pj.select.projectSearch': 'Søk etter prosjekt …',
  'pj.select.activitySearch': 'Søk etter aktivitet …',
  'pj.select.projectEmpty': 'Ingen prosjekter passer søket.',
  'pj.select.activityEmpty': 'Ingen aktiviteter passer søket.',
  'pj.project.createAction': 'Opprett nytt prosjekt',
  'pj.activity.createAction': 'Opprett ny aktivitet',
  'pj.activity.none': 'Prosjektet har ingen aktiviteter ennå. Opprett en her.',
  'pj.lock.state.done': 'Timeføringen er registrert som ferdig til og med {date}.',
  'pj.lock.state.open': 'Timeføringen er ikke registrert som ferdig',
  'pj.lock.markWeek': 'Marker som ferdig til og med uke {week}',
  'pj.lock.undo': 'Angre',
  'pj.lock.done': 'Timeføringen er markert som ferdig til og med uke {week}',
  'pj.lock.undone': 'Timeføringen er åpnet igjen',
  'pj.entry.newTitle': 'Ny timeregistrering',
  'pj.entry.editTitle': 'Endre timeoppføring',
  'pj.entry.invoicedLocked': 'Timene er fakturert og kan ikke endres. Slett eller krediter fakturautkastet for å frigjøre dem.',
  'pj.entry.periodLocked': 'Timeføringen for denne perioden er markert som ferdig.',
  'pj.entry.invoicedShort': 'Fakturert',
  'pj.field.project': 'Prosjekt',
  'pj.field.activity': 'Aktivitet',
  'pj.field.hours': 'Antall timer',
  'pj.field.date': 'Dato',
  'pj.field.description': 'Beskrivelse',
  'pj.field.descriptionHint': 'Hva gikk timene til? Teksten følger med på fakturaen.',
  'pj.field.name': 'Navn',
  'pj.field.number': 'Nummer',
  'pj.field.customer': 'Kunde',
  'pj.field.contact': 'Kontaktperson',
  'pj.field.optional': 'Valgfritt',
  'pj.field.defaultActivity': 'Standard aktivitet',
  'pj.field.product': 'Produkt',
  'pj.field.rate': 'Timepris',
  'pj.field.start': 'Start',
  'pj.field.end': 'Slutt',
  'pj.field.color': 'Farge',
  'pj.field.status': 'Status',
  'pj.overview.title': 'Timeoversikt',
  'pj.overview.week': 'Ukeoversikt',
  'pj.overview.month': 'Månedsoversikt',
  'pj.overview.reports': 'Rapporter',
  'pj.overview.total': 'Sum registrert',
  'pj.overview.billable': '{hours} fakturerbart',
  'pj.overview.weekEntries': 'Registrerte timer i uke {week}',
  'pj.overview.empty': 'Ingen timer registrert i perioden',
  'pj.overview.emptyTitle': 'Ingen timer',
  'pj.filter.all': 'Alle',
  'pj.filter.period': 'Tidsrom',
  'pj.filter.billing': 'Fakturering',
  'pj.filter.billable': 'Fakturerbar',
  'pj.filter.nonBillable': 'Ikke',
  'pj.filter.invoicedLabel': 'Fakturert',
  'pj.filter.invoiced': 'Fakturert',
  'pj.filter.open': 'Ufakturert',
  'pj.report.title': 'Registrerte timer {from} – {to}',
  'pj.report.emptyTitle': 'Ingen registreringer',
  'pj.report.emptyText': 'Ingen timer i valgt periode og filter.',
  'pj.report.print': 'Skriv ut',
  'pj.report.pdf': 'Last ned som PDF',
  'pj.report.pdfTitle': 'Timerapport',
  'pj.report.pdfError': 'Kunne ikke laste ned rapporten.',
  'pj.report.pdfUnavailable': 'Rapport-PDF er ikke koblet til backend.',
  'pj.report.opening': 'Åpner utskrift …',
  'pj.basis.title': 'Fakturagrunnlag',
  'pj.basis.projectName': 'Prosjektnavn',
  'pj.basis.searchPlaceholder': 'Prosjekt, kunde …',
  'pj.basis.summary': '{count} ufakturerte registreringer fra {from} til {to}',
  'pj.basis.selected': 'Valgt',
  'pj.basis.costs': 'Utlegg til viderefakturering',
  'pj.basis.costText': 'Utlegg',
  'pj.basis.costSource': 'Kilde',
  'pj.basis.costAmount': 'Beløp',
  'pj.basis.costEmployee': 'Ansattutlegg · {name}',
  'pj.basis.costPurchase': 'Bokført kjøp',
  'pj.basis.timesheet': 'Lag timeliste-vedlegg',
  'pj.basis.create': 'Opprett fakturautkast',
  'pj.basis.created': 'Fakturautkast opprettet for {project}',
  'pj.basis.pickOne': 'Velg minst én registrering',
  'pj.basis.error': 'Kunne ikke opprette fakturautkastet.',
  'pj.basis.emptyTitle': 'Ingen ufakturerte timer',
  'pj.basis.emptyText': 'Alt er fakturert, eller det er ikke registrert fakturerbare timer på prosjekter med kunde ennå.',
  'pj.cost.tab': 'Utlegg',
  'pj.cost.title': 'Utlegg på prosjekt',
  'pj.cost.party': 'Ansatt / leverandør',
  'pj.cost.voucher': 'Bilag',
  'pj.cost.openVoucher': 'Se bilag',
  'pj.cost.noVoucher': 'Bilaget er ikke tilgjengelig',
  'pj.cost.noVoucherHelp': 'Kostnaden har ingen fil knyttet til seg.',
  'pj.cost.noVoucherShort': 'Uten bilag',
  'pj.cost.pending': 'Til godkjenning',
  'pj.cost.invoiced': 'Fakturert',
  'pj.cost.notBillable': 'Ikke fakturerbar',
  'pj.cost.toInvoice': 'Til fakturering',
  'pj.cost.searchLabel': 'Søk',
  'pj.cost.searchPlaceholder': 'Beskrivelse, ansatt, leverandør …',
  'pj.cost.openSum': '{amount} til fakturering',
  'pj.cost.totalAll': 'Sum alle treff',
  'pj.cost.emptyTitle': 'Ingen utlegg',
  'pj.cost.emptyText': 'Ingen kostnader er koblet til et prosjekt ennå. Bilag knyttes til prosjekt i innboksen, på kjøpet eller når den ansatte sender inn utlegget.',
  'pj.billing.always': 'Alltid',
  'pj.billing.ask': 'Spør',
  'pj.billing.never': 'Aldri',
  'pj.activity.newTitle': 'Ny aktivitet',
  'pj.activity.editTitle': 'Rediger aktivitet',
  'pj.activity.namePlaceholder': 'F.eks. Konsulentbistand',
  'pj.activity.noProduct': 'Ingen',
  'pj.activity.productHint': 'Timene faktureres som «{product}» og bokføres på konto {account}.',
  'pj.activity.noProductHint': 'Uten produkt bokføres timene som tjenestesalg på konto 3020 med standard mva-sats.',
  'pj.activity.rateHint': 'Eks. mva. Står den tom, brukes prisen på produktet.',
  'pj.activity.neverHint': 'Timene holdes utenfor fakturagrunnlaget. Bruk dette for ferie og internt arbeid.',
  'pj.project.newTitle': 'Opprett nytt prosjekt',
  'pj.project.newShort': 'Nytt prosjekt',
  'pj.project.editTitle': 'Rediger prosjekt',
  'pj.project.numberHint': 'Forslag: {number}',
  'pj.project.customerHint': 'Uten kunde kan ikke timene faktureres.',
  'pj.project.noCustomer': 'Ingen kunde (internt prosjekt)',
  'pj.project.closed': 'Avsluttet',
  'pj.settings.title': 'Innstillinger for timeføring',
  'pj.settings.activities': 'Aktiviteter',
  'pj.settings.projects': 'Prosjekter',
  'pj.settings.noActivitiesTitle': 'Ingen aktiviteter ennå',
  'pj.settings.noActivitiesText': 'Aktiviteten bestemmer timepris og hvilket produkt timene faktureres som.',
  'pj.settings.noProjectsFirst': 'Opprett et prosjekt først.',
  'pj.settings.noProjectsTitle': 'Ingen prosjekter ennå',
  'pj.settings.noProjectsText': 'Opprett et prosjekt for å begynne å føre timer.',
  'pj.toast.entrySaved': 'Timene er registrert',
  'pj.toast.entryUpdated': 'Timeoppføringen er oppdatert',
  'pj.toast.entryDeleted': 'Timeoppføringen er slettet',
  'pj.toast.activitySaved': 'Aktiviteten er lagret',
  'pj.toast.activityDeleted': 'Aktiviteten er slettet',
  'pj.toast.projectSaved': 'Prosjektet er lagret',
  'pj.toast.projectDeleted': 'Prosjektet er slettet',
  'pj.error.saveEntry': 'Kunne ikke lagre timeoppføringen.',
  'pj.error.deleteEntry': 'Kunne ikke slette timeoppføringen.',
  'pj.error.saveRows': 'Kunne ikke oppdatere radene.',
  'pj.error.lock': 'Kunne ikke oppdatere låsen.',
  'pj.error.saveActivity': 'Kunne ikke lagre aktiviteten.',
  'pj.error.deleteActivity': 'Kunne ikke slette aktiviteten.',
  'pj.error.saveProject': 'Kunne ikke lagre prosjektet.',
  'pj.error.deleteProject': 'Kunne ikke slette prosjektet.',
  'pj.validation.projectName': 'Prosjektet må ha et navn.',
  'pj.validation.endBeforeStart': 'Sluttdato kan ikke være før startdato.',
  'pj.validation.activityName': 'Aktiviteten må ha et navn.',
  'pj.validation.activityProject': 'Aktiviteten må høre til et prosjekt.',
  'pj.validation.entryDate': 'Timeoppføringen må ha en dato.',
  'pj.validation.entryHours': 'Antall timer må være større enn 0.',
  'pj.validation.entryHoursMax': 'Én registrering kan ikke være mer enn 24 timer.',
  'pj.validation.entryNotFound': 'Fant ikke timeoppføringen.',
  'pj.validation.entryInvoiced': 'Timeoppføringen er allerede fakturert og kan ikke endres.',
  'pj.validation.periodLocked': 'Timeføringen for denne perioden er markert som ferdig.',
  'svc.projectNotFound': 'Fant ikke prosjektet.',
  'svc.projectNumberTaken': 'Prosjektnummeret er allerede i bruk.',
  'svc.projectHasHours': 'Prosjektet har registrerte timer. Marker det som avsluttet i stedet for å slette det.',
  'svc.projectClosed': 'Prosjektet er avsluttet, og kan ikke få nye timer.',
  'svc.projectNeedsCustomer': 'Prosjektet må ha en kunde før timene kan faktureres.',
  'svc.activityNotFound': 'Fant ikke aktiviteten.',
  'svc.activityHasHours': 'Aktiviteten har registrerte timer og kan ikke slettes.',
  'svc.timeEntryNotFound': 'Fant ikke timeoppføringen.',
  'svc.timeTrackingLocked': 'Timeføringen for denne perioden er markert som ferdig.',
  'svc.pickTimeEntries': 'Velg minst én ufakturert timeregistrering.',
  'svc.timesheetInvoiceDescription': 'Timer på {project} i perioden {from} – {to}.',
});
